import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";

const deleteOrder = async (orderId: string) => {
  const res = await api().gersDeleteOrder(orderId);
  return res.data;
};

export const useDeleteOrder = () => {
  const { mutate: deleteOrderMutation, status } = useMutation(deleteOrder);

  return {
    deleteOrderMutation,
    status,
  };
};
